export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13423.10f81419.jpg";